import { useQuery } from '@tanstack/react-query';
import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { getBillingStatus } from '@/api/billing';

/**
 * Dunning (Phase 4b.1): when the signed-in account has a failed payment, prompt them to pay on every
 * dashboard page. 'grace' = payment failed / asking for pay (site still live); 'suspended' = their
 * public sites are offline until they pay. Renders nothing for a healthy ('current') account.
 */
export function PaymentPromptBanner() {
  const { data } = useQuery({
    queryKey: ['billing-status'],
    queryFn: getBillingStatus,
    retry: 1,
    staleTime: 60_000,
  });
  const state = data?.dunning_state;
  if (state !== 'grace' && state !== 'suspended') return null;

  const suspended = state === 'suspended';
  return (
    <div
      role="alert"
      className="flex flex-wrap items-center gap-3 px-6 py-3 text-sm"
      style={{
        background: suspended ? '#FCE4E4' : '#FFF8E7',
        borderBottom: `1px solid ${suspended ? '#F3C6C6' : '#F0E2B8'}`,
      }}
    >
      <AlertTriangle className="h-4 w-4 flex-shrink-0" style={{ color: suspended ? '#C0392B' : '#C9932B' }} />
      <span style={{ color: suspended ? '#8E2A20' : '#7A5E13', fontWeight: 500 }}>
        {suspended
          ? 'Your site is offline because a payment is overdue. Update your payment method to bring it back online.'
          : 'A recent payment didn’t go through. Please update your payment method to keep your site online.'}
      </span>
      <Link
        to="/billing"
        className="ml-auto rounded-md px-3 py-1.5 text-xs font-semibold text-white"
        style={{ background: '#4E1F60' }}
      >
        Update payment
      </Link>
    </div>
  );
}
